import { useEffect, useState } from "react";
import { apiRequest } from "../../network/apiClient";
import {API_ENDPOINTS} from "../../api/apiEndpoints";

export const useLeadJourneyInfoGather = ({leadID}) => {
    const [infoGathering, setInfoGathering] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = async () => {
        if (!leadID) return;
        setIsLoading(true);
        try{
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_LEADS.INFO_GATHERING}?lead_id=${leadID}`, 'GET')
            // const formattedData = {
            //     ...result,
            //     trade_facilities:
            //         typeof result.trade_facilities === 'string'
            //             ? result.trade_facilities.split(',')
            //             : [],
            //     current_provider:
            //         typeof result.current_provider === "string"
            //         ? result.current_provider.split(",")
            //         : [],
            //     currencies:
            //         typeof result.currencies === "string"
            //         ? result.currencies.split(",")
            //         : [],
            // }
            setInfoGathering(result);

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        fetchData();
    }, [leadID]);

    return {infoGatheringAPI: infoGathering, isLoading, refetch: fetchData};
}
